import React from 'react';

const useKeyDown: (func: (e: KeyboardEvent) => void) => void = func => {
  React.useEffect(() => {
    window.addEventListener('keydown', func);
    return () => window.removeEventListener('keydown', func);
  }, [func]);
};

export default useKeyDown;
